<template>
  <div class="assets-page">
    <!-- banner -->
    <el-carousel class="banner" indicator-position="inside">
      <el-carousel-item>
        <div class="banner-item banner1">
          <div class="slogan">
            <h1>让您的资产更具生命力</h1>
            <h3>庆源绿色金融，您的资产管家</h3>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="banner-item banner2">
          <img :src="require('@/assets/img/banner/banner4.png')" alt="" />
          <el-button type="primary" size="small" @click="showFullProcessImg">立即查看</el-button>
        </div>
      </el-carousel-item>
    </el-carousel>

    <!-- search -->
    <div class="search w-1200">
      <el-form
        ref="form"
        :model="searchKeys"
        label-width="150px"
        label-position="left"
      >
        <el-form-item label="资产类型：">
          <el-radio-group v-model="searchKeys.original_type_condi" size="mini">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button
              :label="item.value"
              :key="index"
              v-for="(item, index) in assetsFType"
              >{{ item.label }}</el-radio-button
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="担保方式：" v-show="showGuaranteDes">
          <el-radio-group v-model="searchKeys.guarante_des" size="mini">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button
              :label="item.value"
              :key="index"
              v-for="(item, index) in this.enums.getGuaranteeTypeList"
              >{{ item.label }}</el-radio-button
            >
          </el-radio-group>
        </el-form-item>
        <!--<el-form-item label="资产分类/物权类型：">-->
        <el-form-item :label="assetSTypeLabel">
          <el-radio-group v-model="searchKeys.in_pm_object_type" size="mini">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button
              :label="item.value"
              :key="index"
              v-for="(item, index) in this.enums.collateralTypeList"
              >{{ item.label }}</el-radio-button
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="担保物类型："
          v-show="
            searchKeys.in_pm_object_type &&
              enums.collateralTypeListSecond.length !== 0
          "
        >
          <el-radio-group v-model="searchKeys.pm_object_type" size="mini">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button
              :label="item.value"
              :key="index"
              v-for="(item, index) in this.enums.collateralTypeListSecond"
              >{{ item.label }}</el-radio-button
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上架时间：">
          <span
            class="custom-label"
            :class="{
              selected:
                searchKeys.create_startdate === '' &&
                searchKeys.create_enddate === ''
            }"
            @click="clearDate"
            >全部</span
          >
          <el-date-picker
            v-model="date"
            type="daterange"
            size="mini"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="changeDate"
          ></el-date-picker>
        </el-form-item>
        <!-- 需求暂时不需要 -->
        <!--<el-form-item label="资产摘要：">-->
        <!--<span-->
        <!--class="custom-label"-->
        <!--:class="{ selected: searchKeys.abstract === '' }"-->
        <!--@click="clearAbstract"-->
        <!--&gt;全部</span-->
        <!--&gt;-->
        <!--<el-input-->
        <!--v-model="searchKeys.abstract"-->
        <!--size="mini"-->
        <!--style="width: 350px"-->
        <!--clearable=""-->
        <!--&gt;</el-input>-->
        <!--</el-form-item>-->
        <el-form-item label="所在地区：">
          <span
            class="custom-label"
            :class="{ selected: showAddressFull }"
            @click="clearAddress"
            >全部</span
          >
          <!--<el-input v-model="searchKeys.pm_address" size="mini" style="width: 350px" clearable=""></el-input>-->
          <el-select
            v-model="searchKeys.pm_address_1"
            placeholder="省"
            size="mini"
            clearable
            style="width: 110px;"
          >
            <el-option
              v-for="item in enums.provinces"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            >
              {{ item.label }}
            </el-option>
          </el-select>
          <el-select
            v-model="searchKeys.pm_address_2"
            placeholder="市"
            size="mini"
            clearable
            style="width: 110px; margin-left: 10px;"
            v-if="searchKeys.pm_address_1 !== ''"
          >
            <el-option
              v-for="item in enums.cities"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
          <el-select
            v-if="
              searchKeys.pm_address_1 !== '' && searchKeys.pm_address_2 !== ''
            "
            v-model="searchKeys.pm_address_3"
            placeholder="区"
            size="mini"
            clearable
            style="width: 110px; margin-left: 10px;"
          >
            <el-option
              v-for="item in enums.areas"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <!-- list -->
    <div class="assets-wrapper w-1200">
      <!--<el-row :gutter="30" class="assets">-->
      <!--<el-col :xs="6" :sm="8" :md="8" :lg="6" :xl="6" class="asset" :class="{ 'new-asset': Number(asset.new) === 1 }" v-for="asset in assets" :key="asset.key">-->
      <!--<div class="extra-info">-->
      <!--<p class="label">摘要：</p>-->
      <!--<p class="text abstract">{{ asset.abstractTrans }}</p>-->
      <!--<p class="label address-label">所在地区：</p>-->
      <!--<p class="text address">{{ asset.pm_address || "-" }}</p>-->
      <!--</div>-->
      <!--<div class="date">{{ asset.createdate }}</div>-->
      <!--<div class="main-info" @click="showDetail(asset.id)">-->
      <!--<h3 class="title">{{ asset.title }}</h3>-->
      <!--<p class="des"></p>-->
      <!--<p class="price">{{ asset.creditAmountTrans }}</p>-->
      <!--</div>-->
      <!--</el-col>-->
      <!--</el-row>-->
      <ul class="assets">
        <li class="asset" v-for="asset in assets" :key="asset.key">
          <!-- 债权订单 -->
          <card-1 :data="asset"></card-1>

          <!--<h4 class="title">{{ asset.title }}</h4>-->
          <!--<p class="values">-->
          <!--<span class="highlight-text">{{ asset.creditAmountTrans }}</span>-->
          <!--</p>-->
          <!--<p class="values">-->
          <!--￥<span class="highlight-text">{{ asset.pm_object_evaluation }}</span>-->
          <!--</p>-->
          <!--<p class="abstract">摘要：{{ asset.abstract }}</p>-->
          <!--<p class="description loan">债务人：{{ asset.borrower }}</p>-->
        </li>
      </ul>
      <el-pagination
        v-if="showPagination"
        class="pagination"
        background
        layout="prev, pager, next"
        :total="total"
        :current-page.sync="page"
        :page-size="size"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
    <!-- process image -->
    <el-dialog
      class="full-mask"
      title="操作流程"
      :visible.sync="dialogVisible"
      width="30%"
      :fullscreen="true"
    >
      <img :src="guideUrl" alt="操作流程" />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { toThousandsFormates } from "@/libs/utils";
import enumMixin from "@/mixins/enumerations";
import OrderCard1 from "@/components/OrderCard/Card1";

export default {
  name: "assets",
  mixins: [enumMixin],
  components: {
    "card-1": OrderCard1
  },
  data() {
    return {
      // 枚举
      enums: {
        collateralTypeList: [],
        collateralTypeListSecond: [],
        getGuaranteeTypeList: [],
        provinces: [],
        cities: [],
        areas: []
      },
      searchKeys: {
        // title: "",
        abstract: "",
        // borrower: "",
        // any_collateral: "-2",
        original_type_condi: "",
        guarante_des: "",
        pm_object_type: "",
        in_pm_object_type: "",

        // pm_address: "",
        pm_address_1: "",
        pm_address_2: "",
        pm_address_3: "",
        create_startdate: "",
        create_enddate: ""
      },
      date: "",
      assets: [],
      page: 1,
      size: 10,
      total: 0,
      isLoading: false,
      // 翻页
      showPagination: false,
      // 地区接口数据是否监听change事件就立即更新接口，首次加载页面不需要
      needsUpdateAddress: false,
      // 是否查看完整操作流程图
      dialogVisible: false
    };
  },
  computed: {
    guideUrl() {
      return `${process.env.BASE_URL || "./"}file/apply_guide.png`;
    },

    // 是否显示担保方式
    showGuaranteDes() {
      return this.searchKeys.original_type_condi !== "1";
    },

    // 资产小类label
    assetSTypeLabel() {
      let label = "资产分类/物权类型：";
      let type = this.searchKeys.original_type_condi;

      if (type === "0") {
        label = "债权类型：";
      } else if (type === "1") {
        label = "物权类型：";
      }

      return label;
    },

    showAddressFull() {
      return (
        this.searchKeys.pm_address_1 === "" &&
        this.searchKeys.pm_address_2 === "" &&
        this.searchKeys.pm_address_3 === ""
      );
    },

    ...mapGetters({
      getToken: "getToken",
      getPage: "getPage",
      getOriginalTypeCondi: "getOriginalTypeCondi",
      getGuaranteDes: "getGuaranteDes",
      getPmObjectType: "getPmObjectType",
      getInPmObjectType: "getInPmObjectType",
      getCreateStartdate: "getCreateStartdate",
      getCreateEnddate: "getCreateEnddate",
      getAbstract: "getAbstract",
      getPmAddress1: "getPmAddress1",
      getPmAddress2: "getPmAddress2",
      getPmAddress3: "getPmAddress3"
    }),

    ...mapGetters("enums", ["assetsFType"])
  },
  watch: {
    "searchKeys.original_type_condi"(val) {
      this.setOriginalTypeCondi(val);
      this.search();

      if (val === "1") {
        this.searchKeys.guarante_des = "";
      }
    },
    "searchKeys.guarante_des"(val) {
      this.setGuaranteDes(val);
      this.search();
    },
    "searchKeys.any_collateral"() {
      this.search();
    },
    // 担保物类别
    "searchKeys.in_pm_object_type": {
      async handler(val, oldVal) {
        if (oldVal !== "") {
          this.searchKeys.pm_object_type = "";
          this.enums.collateralTypeListSecond = [];
        }

        if (val) {
          this.enums.collateralTypeListSecond = await this.getPmObjectTypeEnums(
            val
          );
        }
        this.setInPmObjectType(val);
        this.search();
      }
    },
    "searchKeys.pm_object_type"(val) {
      this.setPmObjectType(val);
      this.search();
    },
    "searchKeys.abstract"(val) {
      this.setAbstract(val);
      this.search();
    },
    // "searchKeys.pm_address"() {
    //   this.search();
    // }
    "searchKeys.pm_address_1": {
      handler(val, oldVal) {
        // 在created生命周期中完成赋值之后的手动修改下拉框的值，会调用接口
        if (!this.needsUpdateAddress) {
          return;
        }
        // 手动修改下拉框的值，会触发接口请求
        this.changeProvince(val, oldVal);
      }
    },
    "searchKeys.pm_address_2": {
      handler(val, oldVal) {
        // 在created生命周期中完成赋值之后的手动修改下拉框的值，会调用接口
        if (!this.needsUpdateAddress) {
          return;
        }
        // 手动修改下拉框的值，会触发接口请求
        this.changeCity(val, oldVal);
      }
    },
    "searchKeys.pm_address_3": {
      handler(val) {
        // 缓存
        this.setPmAddress3(val);
        this.search();
      }
    }
  },
  methods: {
    // 初始化查询条件赋值
    async initSearchQuery() {
      this.searchKeys.original_type_condi = this.getOriginalTypeCondi;
      this.searchKeys.guarante_des = this.getGuaranteDes;
      this.searchKeys.in_pm_object_type = this.getInPmObjectType;
      this.searchKeys.pm_object_type = this.getPmObjectType;
      this.searchKeys.create_startdate = this.getCreateStartdate;
      this.searchKeys.create_enddate = this.getCreateEnddate;
      this.searchKeys.abstract = this.getAbstract;
      if (this.getCreateEnddate && this.getCreateEnddate) {
        this.date = [this.getCreateEnddate, this.getCreateEnddate];
      }

      // 地区级联
      this.searchKeys.pm_address_1 = this.getPmAddress1;
      await this.changeProvince(this.getPmAddress1, "null");
      this.searchKeys.pm_address_2 = this.getPmAddress2;
      await this.changeCity(this.getPmAddress2, "null");
      this.searchKeys.pm_address_3 = this.getPmAddress3;

      // 修改状态
      this.needsUpdateAddress = true;

      this.search();
    },

    // 搜索
    search() {
      this.getList();
    },

    // 获取列表
    getList() {
      // 参数
      let param = {
        ...this.searchKeys,
        page: this.page,
        size: this.size
      };
      // 地址参数处理
      this.$request.assets_getAssetsList(param).then(res => {
        if (res.code === 0) {
          this.assets = res.list.list.map((item, index) => {
            let { credit_amount, abstract = null } = item;

            // 摘要
            // let abstractTrans =
            //   abstract.length > 30 ? abstract.slice(0, 30) + "..." : abstract;
            let abstractTrans = "";

            // 金额格式
            let creditAmountTrans = !credit_amount
              ? "-"
              : `￥${toThousandsFormates(credit_amount)}`;

            return { ...item, creditAmountTrans, abstractTrans };
          });
          this.total = res.list.totalRow;
        }
      });
    },

    // 获取查询地址中文
    getAddressCodeFromText(text, list) {
      let res = list.filter(item => item.label === text);

      return res.length > 0 ? res[0]["value"] : "";
    },

    // 日期控件
    changeDate(date) {
      if (date) {
        this.setCreateStartdate(date[0]);
        this.setCreateEnddate(date[1]);
        this.searchKeys.create_startdate = date[0];
        this.searchKeys.create_enddate = date[1];
      } else {
        this.setCreateStartdate("");
        this.setCreateEnddate("");
        this.searchKeys.create_startdate = "";
        this.searchKeys.create_enddate = "";
      }
      this.search();
    },

    // 修改province
    async changeProvince(val, oldVal) {
      if (oldVal !== "") {
        this.searchKeys.pm_address_2 = "";
        this.searchKeys.pm_address_3 = "";

        this.enums.cities = [];
        this.enums.areas = [];
      }

      if (val) {
        let code = this.getAddressCodeFromText(val, this.enums.provinces);
        this.enums.cities = await this.getAddressSelect(code);
      }

      // 缓存
      this.setPmAddress1(val);

      this.search();
    },

    // 修改city
    async changeCity(val, oldVal) {
      if (oldVal !== "") {
        this.searchKeys.pm_address_3 = "";
        this.enums.areas = [];
      }

      if (val) {
        let code = this.getAddressCodeFromText(val, this.enums.cities);
        this.enums.areas = await this.getAddressSelect(code);
      }

      // 缓存
      this.setPmAddress2(val);

      this.search();
    },

    // 清空日期控件
    clearDate() {
      this.date = null;
      this.setCreateStartdate("");
      this.setCreateEnddate("");
      this.searchKeys.create_startdate = "";
      this.searchKeys.create_enddate = "";
      this.search();
    },

    // 清空摘要
    clearAbstract() {
      this.searchKeys.abstract = "";
    },

    // 获取省市区列表
    getAddressSelect(id) {
      return new Promise((resolve, reject) => {
        const param = { p_id: id };
        this.$request
          .assets_getCascadeAddress(param)
          .then(res => {
            if (res.code === 0) {
              resolve(
                res.enums.map(item => ({
                  label: item.address,
                  value: item.code
                }))
              );
            } else {
              resolve([]);
            }
            // resolve(res.code === 0 ? res.enums : []);
          })
          .catch(() => {
            reject([]);
          });
      });
    },

    /**
     * 获取担保物类别
     * @param {string} key 父级key
     */
    getPmObjectTypeEnums(key = "") {
      return new Promise((resolve, reject) => {
        const param = { key };
        this.$request
          .assets_getCascadeCollateralType(param)
          .then(res => {
            // console.log(res)
            if (res.code === 0) {
              let data = [];
              if (!res.enums) {
                resolve(data);
                return;
              }
              Object.keys(res.enums).forEach(keys => {
                data.push({
                  label: res.enums[keys],
                  value: keys
                });
              });
              resolve(data);
            } else {
              resolve([]);
            }
          })
          .catch(() => {
            reject([]);
          });
      });
    },

    // 清空地区
    clearAddress() {
      this.searchKeys.pm_address_1 = "";
      this.searchKeys.pm_address_2 = "";
      this.searchKeys.pm_address_3 = "";
      this.enums.cities = [];
      this.enums.areas = [];
    },

    // 翻页
    changePage(current) {
      this.page = current;
      this.setPage(current);
      this.search();
    },

    // 查看详情
    showDetail(id) {
      this.$router.push({
        name: "assetdetail",
        params: { id }
      });
    },

    showFullProcessImg() {
      this.dialogVisible = true;
    },

    ...mapMutations([
      "setPage",
      "setOriginalTypeCondi",
      "setGuaranteDes",
      "setPmObjectType",
      "setInPmObjectType",
      "setCreateStartdate",
      "setCreateEnddate",
      "setAbstract",
      "setPmAddress1",
      "setPmAddress2",
      "setPmAddress3"
    ])
  },
  async created() {
    // 枚举
    this.enums.collateralTypeList = await this.getPmObjectTypeEnums();
    this.enums.getGuaranteeTypeList = await this.getGuaranteeTypeEnum();
    // 地区
    this.enums.provinces = await this.getAddressSelect("0");

    // 缓存
    this.page = this.getPage;
    this.initSearchQuery();

    // 处理翻页控件设置了默认currentPage但是显示上有问题
    this.$nextTick(() => {
      this.showPagination = true;
    });

    this.getPmObjectTypeEnums();

    this.search();
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/pages/assets.scss";
</style>
